import { render, staticRenderFns } from "./couponReceiveRecords.vue?vue&type=template&id=5d9251be&"
import script from "./couponReceiveRecords.vue?vue&type=script&lang=js&"
export * from "./couponReceiveRecords.vue?vue&type=script&lang=js&"
import style0 from "./couponReceiveRecords.vue?vue&type=style&index=0&id=5d9251be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports